import Vue from "vue";

import TransactionLogPurchases from "./TransactionLogPurchases.vue";

export function load() {
    const selector = "transaction-log-purchases";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(TransactionLogPurchases, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
